import { useMemo } from "react"
import { UserState } from "@app/storage"
import { useSnapshot } from "valtio"
import { resetCalculatorData, useUserAssessentPauseCallback } from "@app/helpers"

export const useImpersonationBannerManage = () => {
  const { user } = useSnapshot(UserState)

  const pauseUserAssessment = useUserAssessentPauseCallback()

  const [userName, districtName] = useMemo(
    () => {
      const userName = [user?.firstName, user?.lastName].filter(item => !!item?.trim()).join(' ') || "--"
      const districtName = user?.schoolDistrictName || '--'

      return [userName, districtName]
    },
    [user],
  )

  const onLeaveImpersonation = () => {
    const targetUrl = `${process.env.REACT_APP_TEST_CALLBACK_URL}/leave-impersonation`
    
    resetCalculatorData()
    pauseUserAssessment()

    window.open(targetUrl, '_self')
  }

  return {
    userName,
    districtName,
    impersonationEnable: !!user?.impersonatedBy,
    onLeaveImpersonation
  }
}